import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import StandardError from 'components/common/standard_error'
import Modal from 'components/common/modal'
import { includes } from 'lodash'
import cssModules from 'react-css-modules'
import styles from './campaign_eligibility.less'
import { getI18n } from 'client/i18n'
import {
  NO_DESCRIPTION_ERRORS,
  DEXTER_SPECIFIC_ERRORS,
  CIP_ELIGIBILITY_CODES,
} from 'shared/shared_consts'

const i18n = getI18n('components/common/campaign_eligibility')

class CampaignEligibility extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    CIPStatusCode: PropTypes.string,
  }

  render() {
    let { CIPStatusCode } = this.props
    CIPStatusCode =
      includes(DEXTER_SPECIFIC_ERRORS, CIPStatusCode) ||
      includes(CIP_ELIGIBILITY_CODES, CIPStatusCode)
        ? CIPStatusCode
        : 'ERROR'
    const title = i18n(`title.${CIPStatusCode}`)
    const description = includes(NO_DESCRIPTION_ERRORS, CIPStatusCode)
      ? ''
      : i18n(`description.${CIPStatusCode}`)
    return (
      <Modal animate={false} showClose={false}>
        <div styleName="eligibilty-errors">
          <StandardError
            iconType="warning"
            title={title}
            subtitle={description}
          />
          <a
            data-pa-click="goToAccount"
            href="/myaccount/summary"
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="go-to-account-button"
          >
            {i18n('go_to_account_button')}
          </a>
        </div>
      </Modal>
    )
  }
}
export default connect((state, ownProps) => {
  return {
    CIPStatus: state.current_user.CIPStatus,
    CIPStatusCode: state.current_user.CIPStatusCode,
    ...ownProps,
  }
})(cssModules(CampaignEligibility, styles))
